/**
 * @generated SignedSource<<b588996827365d008ed74b4e71a1be7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RegionsFieldCountryQuery$variables = {
  searchParam: string;
};
export type RegionsFieldCountryQuery$data = {
  readonly viewer: {
    readonly locations: ReadonlyArray<{
      readonly countryId: number | null;
      readonly fullSubtitle: string | null;
      readonly fullTitle: string;
      readonly locationId: string;
    } | null> | null;
  } | null;
};
export type RegionsFieldCountryQuery = {
  response: RegionsFieldCountryQuery$data;
  variables: RegionsFieldCountryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchParam"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "searchParam"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullTitle",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullSubtitle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegionsFieldCountryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LocationListNode",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "kind": "RequiredField",
                "field": (v2/*: any*/),
                "action": "NONE",
                "path": "viewer.locations.fullTitle"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "RequiredField",
                "field": (v5/*: any*/),
                "action": "NONE",
                "path": "viewer.locations.locationId"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegionsFieldCountryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LocationListNode",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "105f4441ef03a1e380c6c34782f1845a",
    "id": null,
    "metadata": {},
    "name": "RegionsFieldCountryQuery",
    "operationKind": "query",
    "text": "query RegionsFieldCountryQuery(\n  $searchParam: String!\n) {\n  viewer {\n    locations(search: $searchParam) {\n      fullTitle\n      fullSubtitle\n      countryId\n      locationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "19a800bd72a851ca95fa6689d88dd03f";

export default node;
